import React from 'react'
import { ZdsIcon, ZdsTypography } from '@zera/components'
import { logEvent } from 'firebase/analytics'
import { OpenChatButton } from './styles'
import { useOpenCloseUpdater } from '~/context'
import { analytics } from '~/firebase-analytics'

export const OpenChatLLM = () => {
  const { open } = useOpenCloseUpdater()
  const handleOpenChat = () => {
    open()
    logEvent(analytics, 'gpt_chat_open')
  }

  return (
    <OpenChatButton onClick={handleOpenChat}>
      <ZdsTypography color="neutral100" variant="title400">
        IA Interativa
      </ZdsTypography>
      <ZdsIcon src="MiArrowheadTop" />
    </OpenChatButton>
  )
}
